export { default } from './CardSellsTopCategories'


// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardSellsTopCategories/index.js